export default{
  districts: (state) => state.districts,
  districtTo: (state) => state.districtTo,
  districtFrom: (state) => state.districtFrom,
  districtKind: (state) => state.districtKind,
  district: (state) => state.district
}



// WEBPACK FOOTER //
// ./src/components/district/store/getters.js